import type {PromotionCycle} from '../../../../types';

import {ClockCircleOutlined} from '@ant-design/icons';
import {useCountdownToDate} from '@countdown-timer';
import {Button, Card} from '@ds/components';
import promotionIcon from 'assets/images/promotion-center/new/tn.svg';
import {useNavigate} from 'react-router-dom';
import {routes} from 'routes/routes';

import StockAvailability from '../../../common/StockAvailability/StockAvailability';

type AvailableDiscountCardProps = {
  cycle: PromotionCycle;
  description: string;
};

const AvailableDiscountCard: React.FC<AvailableDiscountCardProps> = ({cycle, description}) => {
  const navigate = useNavigate();
  const {timeRemaining} = useCountdownToDate({targetDate: new Date(cycle.deal_end_date)});
  const countdown = typeof timeRemaining === 'string' ? timeRemaining : timeRemaining.full;

  return (
    <Card className="w-full border-gray-22 [&>div]:p-4" size="small">
      <div className="flex flex-col gap-4">
        <div className="flex items-start justify-between gap-3">
          <img className="size-10 shrink-0" src={promotionIcon} alt="" aria-hidden />
          <span className="flex items-center gap-1.5 text-body-sm-emphasis text-neutral-fg">
            <bdi>{countdown}</bdi>
            <ClockCircleOutlined aria-hidden />
          </span>
        </div>
        <div className="flex flex-col gap-1">
          <h2 className="text-body-sm-emphasis text-neutral-fg">{cycle.title}</h2>
          <p className="text-body-sm text-gray-07">{description}</p>
        </div>
        <div className="mx-7.5 my-2.5">
          <StockAvailability stockAvailability={cycle.stock_availability} />
        </div>
        <Button
          fullWidth
          disabled={!cycle.disable}
          onClick={() =>
            navigate(
              routes.PROMOTION_CENTER_CAMPAIGN.replace(':cycleId', String(cycle.cycle_id || 1))
            )
          }
        >
          {cycle.disable ? 'شرکت در دوره تخفیف' : 'شرکت در دوره تخفیف بعدی'}
        </Button>
      </div>
    </Card>
  );
};

export default AvailableDiscountCard;
